export default __webpack_public_path__ + "static/media/logo-sidebar-2.69fe9083.jpg";